import React from "react";
import img from '../../assets/benefit-img.png'

const Benefits = () => {
  return (
    <div id="benefit-page">
      <p id="benefit-title">Benefits</p>

      <div id="benefit-div-comp">
        <img src={img} id="benefit-img" alt=""/>
        <div id="benefit-div">
          <p id="benefit-div-title">TEACH & LEARN</p>
          <p id="benefit-div-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        </div>
        <div id="benefit-div">
          <p id="benefit-div-title">TEACH & LEARN</p>
          <p id="benefit-div-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        </div>
        <div id="benefit-div">
          <p id="benefit-div-title">TEACH & LEARN</p>
          <p id="benefit-div-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        </div>
        <div id="benefit-div">
          <p id="benefit-div-title">TEACH & LEARN</p>
          <p id="benefit-div-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
